import "./style.scss";
import "./style-mob.scss";
import whyChooseBg from "@/src/assets/HomePage/WhyChoose/why-choose-bg.png";
import Alert from "@/src/assets/HomePage/WhyChoose/alert.png";
import ReadMoreBtn from "@/src/components/ReadMoreBtn/ReadMoreBtn";
import whyChooseMob from "@/src/assets/HomePage/WhyChoose/why-choose-mob.png";
import { Link } from "react-router-dom";
import RedLineForTitle from "../../RedLineForTitle/RedLineForTitle";

const WhyChoose = () => {
  return (
    <>
      {window.innerWidth <= 767 ? (
        <Link to={"/single-page/our-advantages"} className="why-choose-mob container">
          <img src={whyChooseMob} alt="Img" />
        </Link>
      ) : (
        <div className="why-choose section-margin-top">
          <div className="why-choose-bg">
            <img src={whyChooseBg} alt="why Choose Bg" />
          </div>
          <div className="why-choose-content">
            <RedLineForTitle title={"Почему выбирают mШмБ?"} />
            <div className="why-choose-description">
              <p>
                <strong>Мальтийская школа медицины и бизнеса</strong> это современный и динамично развивающийся университет, расположенный в
                Мальте, англоязычной стране Европейского союза. Университет предлагает качественное образование по доступной цене и открыт
                для студентов из разных уголков мира.
              </p>
              <p>
                Мы объединяем два ключевых направления будущего медицину и бизнес, предоставляя студентам возможность изучать наиболее
                востребованные специальности. Программы разрабатываются с участием международных экспертов и практиков, а обучение ведется с
                фокусом на прикладные знания и реальные профессиональные навыки.
              </p>
              <p>
                Университет располагает современными учебными пространствами, доступом к более чем 70 000 учебным материалам онлайн и
                комфортной академической средой. Студенты чувствуют себя частью сплоченного международного сообщества.
              </p>
              <p>
                <strong>Мальтийская школа медицины и бизнеса</strong> активно сотрудничает с европейскими университетами, клиниками,
                бизнес-школами и компаниями. Наша партнерская сеть в ЕС и поддержка со стороны международных стейкхолдеров открывают
                студентам доступ к стажировкам, программам обмена и карьерным возможностям в Европе.
              </p>
            </div>
            <div className="why-choose-alert">
              <img src={Alert} alt="Alert" />
              <p>Поступайте в MSMB — сделайте шаг к международному признанию, знаниям и возможностям уже сегодня!</p>
            </div>
            <div className="why-choose-link">
              <ReadMoreBtn text="Подробнее →" link="/single-page/our-advantages" />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default WhyChoose;
